import { useMemo } from 'react';
import { useCustomEmoji } from './useCustomEmoji';

interface UseCommentLikeEmojiArgs {
  isLiked: boolean;
  size: number;
}

export const useCommentLikeEmoji = ({ isLiked, size }: UseCommentLikeEmojiArgs) => {
  const { customEmoji: inactiveEmoji } = useCustomEmoji({ emojiKey: 'commentLike', size });

  const { customEmoji: activeEmoji } = useCustomEmoji({ emojiKey: 'commentLikeActive', size });

  const commentLikeEmoji = useMemo(() => {
    if (!inactiveEmoji || !activeEmoji) {
      return null;
    }

    if (isLiked) {
      return activeEmoji;
    }

    return inactiveEmoji;
  }, [activeEmoji, inactiveEmoji, isLiked]);

  return { commentLikeEmoji };
};
